import moment from "moment/moment";

const woChatReducer = (state = {}, action) => {
    switch (action.type) {
        case 'LEAVE_WORK_ORDER':
            return Object.assign({}, state, {
                data: action.data
            });
        case 'JOIN_WORK_ORDER':
            return Object.assign({}, state, {
                data: {},
                messages: {
                    UserMessages: []
                }
            });
        case 'WORK_ORDER_MESSAGES':
            action.data.UserMessages = action.data.UserMessages.sort((a, b) => {
                return moment(a.CreateUpdateDate).isAfter(moment(b.CreateUpdateDate)) ? 1 : -1;
            });

            return Object.assign({}, state, {
                messages: action.data ?? {
                    UserMessages: []
                }
            });
        case 'WORK_ORDER_MESSAGE_RECEIVED': {
            if (!!action.data.Message) {
                action.data.Message = parseHtmlMessageWithMentions(action.data.Message);
            }

            let prevMessages = state.messages;
            if (!!state?.messages?.UserMessages && state?.messages?.UserMessages.length > 0) {
                prevMessages.UserMessages.push(action.data);
            } else {
                prevMessages.UserMessages = [action.data];
            }

            return Object.assign({}, state, {
                messages: prevMessages,
                UserMessagesCount: prevMessages?.UserMessages?.length ?? 0
            });
        }
        default:
            return state;
    }
}

const parseHtmlMessageWithMentions = (message) => {
    const matches = message.match(/@{{@([^}]+)}}/g);

    if (matches?.length) {
        matches.forEach(it => {
            let mention = it.replace('@{{@', "");
            mention = mention.replace('}}', "").split("|");
            const name = mention[0];
            const id = mention[1];
            const htmlMention = `<button data-contact-id="${id}" data-name="${name}" class="mention">${name}</button>`;

            message = message.replace(it, htmlMention)
        })
    }

    return message;
}

export default woChatReducer;